import { Link } from 'react-router-dom';
import card from '../../styles/shared/publicCard.module.css';

export default function NotFoundPage() {
  return (
    <div className={card.centeredPage}>
      <h1>404 — Not Found</h1>
      <Link to="/">Go home</Link>
    </div>
  );
}
